export const NAME = "offers"
export const FIREBASE_PATH_OFFERS = "offers"
